<template>
  <UiBaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    class="icon"
  >
    <path
      d="M11.1982 4.09884C12.1086 4.09884 12.8534 3.34535 12.8534 2.42442C12.8534 1.50349 12.1086 0.75 11.1982 0.75C10.2879 0.75 9.54302 1.50349 9.54302 2.42442C9.54302 3.34535 10.2879 4.09884 11.1982 4.09884ZM14.9141 8.57031C14.3047 8.57031 14.0152 8.34323 13.7891 8.22471C13.1046 7.86601 12.5521 7.32976 12.1913 6.69419L11.3637 5.35465C11.0244 4.81046 10.4451 4.51744 9.84095 4.51744C9.19543 4.51744 8.52507 4.93605 8.36783 5.72302L6.02573 17.7119C5.91814 18.2477 6.32366 18.75 6.86988 18.75C7.2754 18.75 7.62299 18.4653 7.71403 18.0719L9.04646 12.0523L10.7844 13.7267V17.9128C10.7844 18.3733 11.1568 18.75 11.612 18.75C12.0672 18.75 12.4396 18.3733 12.4396 17.9128V13.1909C12.4396 12.7305 12.2575 12.2951 11.9265 11.977L10.7017 10.7965L11.1982 8.28488C11.7482 8.92468 12.448 9.45726 13.2417 9.82367C13.6425 10.0086 14.4961 10.2266 14.9141 10.2266C15.332 10.2266 15.75 9.90234 15.75 9.39844C15.75 8.89453 15.3242 8.57031 14.9141 8.57031ZM6.1747 10.4867L4.42019 10.1435C3.97329 10.0514 3.67535 9.61605 3.76639 9.16395L4.39536 5.87372C4.56916 4.96953 5.43813 4.37512 6.33194 4.55093L7.29195 4.74349L6.1747 10.4867Z"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>
